import styled from 'styled-components'
import BasicTooltip from './BasicTooltip'

const MinimalTooltip = styled(BasicTooltip)`
  padding: 6px;
`
export default MinimalTooltip
